import { ProyectosPlataformaService } from "../../../shared/generated/grpc/plataforma_proyectos_pb";
import { MacroProyectoResponse } from "../../../shared/response/proyectos/MacroProyectoResponse";
import { MacroProyectoPayload } from "../../../shared/services/api/payload/proyectos/MacroProyectoPayload";
import { ServiceSaveBase } from "../../../shared/services/base/ServiceSaveBase";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";
import { MacroProyectoService, toMacroProyectoResponse } from "./MacroProyectoService";

/** Alta y edición de Macro-Proyectos; el resultado reemplaza la fila del listado. */
export class MacroProyectoSaveService extends ServiceSaveBase<MacroProyectoResponse, MacroProyectoPayload> {
  protected readonly cache = MacroProyectoService.instance;

  /**
   * gRPC-Web (`GuardarMacroProyecto`): reemplaza siempre el set completo de cultivos. Falla si el
   * Macro-Proyecto ya está cerrado.
   */
  protected async sendSave(p: MacroProyectoPayload): Promise<MacroProyectoResponse> {
    const r = await grpcCall(() => grpcClient(ProyectosPlataformaService).guardarMacroProyecto({
      id: p.id ?? undefined,
      nombre: p.nombre,
      cosechaId: p.cosechaId,
      region: p.region,
      descripcion: p.descripcion ?? undefined,
      cultivoIds: p.cultivoIds,
    }));
    return toMacroProyectoResponse(r);
  }
}
